export default function useSetContentTypeToCssClass() {
  function assignContentTypeToCssClass(type: string, contentType: string) {
    const contentRegex = contentType.match('url')
      ? 'url'
      : contentType.match('^image')
      ? 'image'
      : contentType.match('pdf$')
      ? 'pdf'
      : contentType.match('word')
      ? 'word'
      : contentType.match('^audio')
      ? 'audio'
      : contentType.match('^video')
      ? 'video'
      : 'file';

    switch (contentRegex) {
      case 'image':
        if (type == 'iconClass') {
          return 'bi bi-file-earmark-image';
        }
        if (type == 'class') {
          return 'icon-color-purple';
        }
        break;
      case 'pdf':
        if (type == 'iconClass') {
          return 'bi bi-file-earmark-pdf';
        }
        if (type == 'class') {
          return 'icon-color-red';
        }
        break;
      case 'word':
        if (type == 'iconClass') {
          return 'bi bi-file-earmark-word';
        }
        if (type == 'class') {
          return 'icon-color-blue';
        }
        break;
      case 'url':
        if (type == 'iconClass') {
          return 'bi bi-globe-europe-africa';
        }
        if (type == 'class') {
          return 'text-primary';
        }
        break;
      case 'audio':
        if (type == 'iconClass') {
          return 'bi bi-file-earmark-music';
        }
        break;
      case 'video':
        if (type == 'iconClass') {
          return 'bi bi-file-earmark-play';
        }
        break;
      default:
        if (type == 'iconClass') {
          return 'bi bi-file-earmark';
        }
    }
  }

  return {
    assignContentTypeToCssClass,
  };
}
